"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

var CapabilitiesService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(CapabilitiesService, _DAO);

  var _super = _createSuper(CapabilitiesService);

  function CapabilitiesService() {
    (0, _classCallCheck2["default"])(this, CapabilitiesService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CapabilitiesService, [{
    key: "_createUrl",

    /**
     * Helper method to create the capabilities api url
     * @param {String} resourceUrl
     * @param {Boolean} skipUriEncoding - whether to skipUriEncoding or not
     */
    value: function _createUrl(resourceUrl, skipUriEncoding) {
      var urn = (0, _utils.getUrn)(resourceUrl);

      if (!urn && this.apiVersion.toUpperCase() === 'V4') {
        throw new Error('Missing Resource URN');
      }

      if (urn) {
        return this.apiVersion.toUpperCase() === 'V4' ? "".concat(this.endpoint, "/capabilities/").concat(skipUriEncoding ? urn : encodeURIComponent(urn)) : "".concat(this.endpoint, "/capabilities/urn/").concat(skipUriEncoding ? urn : encodeURIComponent(urn));
      }

      return "".concat(this.endpoint, "/capabilities/").concat(skipUriEncoding ? (0, _utils.getUrlPath)(resourceUrl) : (0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)));
    }
    /**
    * Get collaborations for the user.
    * @param {Object} request - request object 
    *   @property {String} resourceUrl - CC Storage path (path based or ID-based)
    *   @property {Boolean} skipUriEncoding - whether to skipUriEncoding or not
    * @returns {Promise}
    */

  }, {
    key: "get",
    value: function get(request) {
      var _ref = request || {},
          resourceUrl = _ref.resourceUrl,
          skipUriEncoding = _ref.skipUriEncoding,
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {
        extraFeatures: 'orgEverybody'
      } : _ref$params;

      if (!resourceUrl) {
        throw new Error('Missing Resource Path');
      }

      return this.getRequest({
        params: params,
        url: this._createUrl(resourceUrl, skipUriEncoding)
      });
    }
  }]);
  return CapabilitiesService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(CapabilitiesService, InstanceConfig);

exports["default"] = _default;